export default function monitorInputChange(eleId){
    let ele = document.getElementById(eleId);
    if (ele) {
      ele.style.borderColor = 'white';
    }
}